import React from "react";

const SvgComponent = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M15.1 1.81l-2.83 2.83c-.77.78-.77 2.05 0 2.83l1.41 1.41-4.55 4.55-2.82-2.83L4.89 12c-4.95 5-1.39 8.5-1.39 8.5S7 24 12 19.09l1.41-1.41-2.8-2.8 4.54-4.54 1.39 1.39c.78.77 2.05.77 2.83 0L22.2 8.9l-7.1-7.09m2.83 8.47L16.55 8.9l-1.44-1.44-1.4-1.4 1.41-1.41 4.23 4.23-1.42 1.4z" />
  </svg>
);

export default __webpack_public_path__ +
  "static/media/disturbance.01eea908.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/map-icons/disturbance.svg